export const WAVE_COLOR = '#1A1A1A';
export const PLAYED_COLOR = '#00787A';
export const WAVE_HEIGHT = 26;

// The default Trusted Types policy strips <style>, so WaveSurfer's shadow CSS never applies
// and the progress canvas is laid out under the waveform instead of on top of it.
const waveSurferLayoutStyles = (height: number): string => `
:host {
    display: block;
    height: ${height}px;
    overflow: hidden;
    user-select: none;
    min-width: 1px;
}
:host audio { display: none; }
:host .scroll {
    overflow: hidden;
    width: 100%;
    height: ${height}px;
    position: relative;
}
:host .wrapper {
    position: relative;
    overflow: hidden;
    height: ${height}px;
}
:host .canvases {
    min-height: ${height}px;
    height: ${height}px;
    pointer-events: none;
}
:host .canvases > div { position: relative; }
:host canvas {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
}
:host .progress {
    pointer-events: none;
    position: absolute;
    z-index: 2;
    top: 0;
    left: 0;
    width: 0;
    height: 100%;
    overflow: hidden;
}
:host .progress > div { position: relative; }
:host .cursor {
    pointer-events: none;
    position: absolute;
    z-index: 5;
    top: 0;
    left: 0;
    height: 100%;
    border-radius: 2px;
}
`;

export const createWaveSurferOptions = () => ({
    height: WAVE_HEIGHT,
    waveColor: WAVE_COLOR,
    progressColor: PLAYED_COLOR,
    cursorColor: PLAYED_COLOR,
    cursorWidth: 1,
    normalize: true,
    // Live recording must not seek. Playback turns interaction on once audio is decoded.
    interact: false,
    hideScrollbar: true,
    fillParent: true,
    autoScroll: false,
    autoCenter: false,
    minPxPerSec: 0,
});

export const applyWaveSurferLayout = (container: HTMLElement): void => {
    const host = container.firstElementChild;
    const root = host instanceof HTMLElement ? host.shadowRoot : null;
    if (!root || root.querySelector('style[data-audio-wave]')) {
        return;
    }
    const style = document.createElement('style');
    style.dataset.audioWave = 'true';
    style.textContent = waveSurferLayoutStyles(WAVE_HEIGHT);
    root.appendChild(style);
};
